export default __webpack_public_path__ + "static/media/canada_flag.74831bc6.png";